import { AnalyiticsAppDownload, Analytics } from '@components/analytics/analytics';
import Button from '@components/common/Button';
import Image from '@components/images/RentennialsNextImage';
import TopMenu from '@components/menu/RentennialsMenu';
import { DEEP_LINK_PAGES } from '@constants/index';
import { tw } from '@utils/tailwind-utils';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

const NotFoundError = () => {
  const router = useRouter();
  const path = router.asPath;

  const isDeepLink = DEEP_LINK_PAGES.some((links) => path.includes(links));

  const handleTrackGoToAppStore = () => {
    Analytics.event(AnalyiticsAppDownload.APP_STORE, {
      date: new Date()
    });
  };
  const handleTrackGoToPlayStore = () => {
    Analytics.event(AnalyiticsAppDownload.PLAY_STORE, {
      date: new Date()
    });
  };

  const { t } = useTranslation('common');

  return (
    <div className="h-screen bg-gray-200/50">
      <TopMenu
        hasBg={true}
        className={tw('h-auto justify-center pb-4')}
        containerClassName="flex w-[1100px] items-center justify-between pt-6  mobile:px-4 h-auto"
        logoClassName="min-w-[180px]"
      />
      {isDeepLink ? (
        <div className="flex h-[calc(100vh-80px)] w-full flex-col items-center justify-center gap-y-4 px-4">
          <div className="mx-auto w-full max-w-[550px] rounded-[40px] border-[1px] border-gray-200/50 shadow-lg">
            <div
              className=" rounded-t-[40px] bg-cover bg-no-repeat"
              style={{ backgroundImage: 'url(/images/Header_Modal_Reserva.svg)', backgroundPositionY: '-18px' }}
            >
              <div className="py-10">
                <div className="flex w-full justify-center">
                  <p className="w-[460px] px-4 text-center font-bree-serif text-xl font-normal leading-5 text-white tablet:text-3xl tablet:leading-8">
                    {t('common:400.app-title')}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="px-5 py-10 tablet:px-10">
                <p className="text-center font-bree-serif text-sm font-normal text-rentennials-text tablet:text-lg">
                  {t('common:400.app-description')}
                  <br />
                  {t('common:400.app-description-2')}
                </p>
              </div>
              <div className="flex w-full justify-center gap-x-2 gap-y-2 pb-8 pt-4">
                <Link
                  passHref
                  onClick={handleTrackGoToPlayStore}
                  legacyBehavior
                  href="https://play.google.com/store/apps/details?id=com.rentennials"
                >
                  <a target="_blank" rel="noopener noreferrer">
                    <Image
                      src="/images/Google_Play_Store.svg"
                      alt="google playstore"
                      width={165}
                      height={44}
                      className="h-[44px] w-[125px] tablet:w-[165px]"
                    />
                  </a>
                </Link>
                <Link
                  passHref
                  onClick={handleTrackGoToAppStore}
                  legacyBehavior
                  href="https://apps.apple.com/us/app/rentennials-app/id1621858062"
                >
                  <a target="_blank" rel="noopener noreferrer">
                    <Image
                      src="/images/Apple_Store.svg"
                      alt="apple store"
                      width={165}
                      height={44}
                      className="h-[44px] w-[125px] tablet:w-[165px]"
                    />
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex h-[calc(100vh-80px)] w-full flex-col items-center justify-center gap-y-4">
          <Image alt="400" src="/images/404.png" width={400} height={400} />
          <p className="w-[260px] text-center font-bree-serif font-normal text-gray-800">{t('common:400.title')}</p>
          <Link href="/">
            <Button className="rounded-[20px] bg-rentennials-primary px-4">
              <p className="p-2 font-bree-serif font-normal text-white">{t('common:400.description')}</p>
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default NotFoundError;
